// extracted by mini-css-extract-plugin
module.exports = {"fixed-tab-list":"fixed-tab-list_fixed-tab-list__8KdG6","fixed-tab-list__item":"fixed-tab-list_fixed-tab-list__item__26__p","is-active":"fixed-tab-list_is-active__1hz6j"};